import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "color", "detached", "disabled", "size"];
import unescapedText from 'I18n/utils/unescapedText';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { useContext } from 'react';
import { DialogButton } from '../DialogButton/DialogButton';
import { DialogContext } from '../Dialog/DialogContext';
import { RemoveIcon } from 'foundations-assets';
import { CloseButtonProvider } from './CloseButtonProvider';
import { useTheme } from 'foundations-theming/utils';
import { usePopoverCloseButtonContext } from '../Popover/PopoverCloseButtonContext';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { mergeOverrides } from '../../../utils/mergeOverrides';
import { useTagContext } from '../Tag/TagProvider';
import { useMoveableObjectContext } from '../MoveableObject/MoveableObjectProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseButton = _ref => {
  var _popoverCloseButtonCo, _tagContext$closeButt, _moveableObjectContex;
  let {
      'aria-label': ariaLabel = unescapedText('salesUI.UICloseButton.label'),
      color,
      detached,
      disabled = false,
      size = 'lg'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const popoverCloseButtonContext = usePopoverCloseButtonContext();
  const tagContext = useTagContext();
  const moveableObjectContext = useMoveableObjectContext();
  const SIZE_OPTIONS = {
    sm: {
      size: '8px',
      padding: theme.space['300']
    },
    md: {
      size: '12px',
      padding: theme.space['400']
    },
    lg: {
      size: '16px',
      padding: theme.space['500']
    },
    xl: {
      size: '36px',
      padding: '38px' // TODO: Needs token
    }
  };
  const sizeOptions = SIZE_OPTIONS[toShorthandSize(size)];
  const useType = useContext(DialogContext).use;
  const sharedStyleOverrides = mergeOverrides((_popoverCloseButtonCo = popoverCloseButtonContext === null || popoverCloseButtonContext === void 0 ? void 0 : popoverCloseButtonContext.closeButtonStyleOverrides) !== null && _popoverCloseButtonCo !== void 0 ? _popoverCloseButtonCo : {}, (_tagContext$closeButt = tagContext === null || tagContext === void 0 ? void 0 : tagContext.closeButtonStyleOverrides) !== null && _tagContext$closeButt !== void 0 ? _tagContext$closeButt : {}, (_moveableObjectContex = moveableObjectContext === null || moveableObjectContext === void 0 ? void 0 : moveableObjectContext.closeButtonStyleOverrides) !== null && _moveableObjectContex !== void 0 ? _moveableObjectContex : {});
  const dialogButtonStyleOverrides = deepMerge({
    position: 'absolute',
    insetInlineEnd: detached && size === 'xl' ? '40px' : '24px',
    insetBlockStart: detached && size === 'xl' ? '40px' : '24px',
    fontSize: sizeOptions.size,
    // Setting `font-size` instead of setting the `iconSize` prop to allow for non-tokenized icon sizes
    color: color ? theme.color[color] : useType === 'conversational' ? theme.color['text-core-disabled'] : undefined,
    '&::after': {
      paddingBlock: sizeOptions.padding,
      paddingInline: sizeOptions.padding
    }
  }, sharedStyleOverrides !== null && sharedStyleOverrides !== void 0 ? sharedStyleOverrides : {});
  return /*#__PURE__*/_jsx(CloseButtonProvider, {
    dialogButtonStyleOverrides: dialogButtonStyleOverrides,
    children: /*#__PURE__*/_jsx(DialogButton, Object.assign({}, rest, {
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      "data-action": "close",
      detached: detached,
      icon: RemoveIcon,
      iconSize: "inherit" // Setting the icon size to `inherit` so that we can use non-tokenized icon sizes via `font-size`
    }))
  });
};